// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cc[data-v-3d1ef29f] {\n  height: var(--layout-height);\n  width: var(--layout-width);\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 39999;\n}\n.pageAsOverlay[data-v-3d1ef29f] {\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
